<latch-make-key (back)="onBackClick()" (done)="onDoneClick($event)"></latch-make-key>
